export default "__VITE_ASSET__DZNYIRZ1__"